import { render, staticRenderFns } from "./PDFIcon.vue?vue&type=template&id=66129b96"
var script = {}


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('66129b96')) {
      api.createRecord('66129b96', component.options)
    } else {
      api.reload('66129b96', component.options)
    }
    module.hot.accept("./PDFIcon.vue?vue&type=template&id=66129b96", function () {
      api.rerender('66129b96', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/icons/PDFIcon.vue"
export default component.exports